export default {
  academics: (param) => `profile/academics?${buildQuery(param)}`,
  editacademics: "profile/academics/update",
  postacademics: "profile/academics",
  deleteacademics: (param) => `profile/academics/destroy?${buildQuery(param)}`,
};

function buildQuery(param) {
  const query = new URLSearchParams(param);
  return query.toString();
}
